/**
 * DVL copy-link — share what the shopper actually configured
 * ==========================================================
 * The themes' own share buttons are rendered in Liquid from the product URL, so they are frozen at
 * page load: no `?variant=`, no `?spo=`. A shopper who builds a kit and hits Share sends a blank
 * product page, which is the opposite of what the kit builder and the lens chart's preset links exist
 * for. This adds a Copy link button that copies the URL as it stands AT THE MOMENT OF THE CLICK -
 * variant, SPO preset and all.
 *
 * Dawn is excluded: its native share-button.liquid already does copy-to-clipboard.
 *
 * THEME-AGNOSTIC BY IMITATION. Rather than three sets of hard-coded classes, the button copies the
 * className of a share link already in the strip, so it inherits whatever that theme styles its share
 * controls with. Only the icon and the copied-state are ours.
 *
 * Targets the VISIBLE strip: Fashionopolism ships a hidden div.product__section--share beside the
 * shown one, and Prestige a hidden div.Product__ShareList, so "the first match" is the wrong element
 * about half the time - the same trap as the add-to-cart form.
 */
(function () {
  'use strict';

  var MARK = 'data-dvl-copy';
  var LABEL = 'Copy link';
  var DONE = 'Copied';

  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="9" y="9" width="11" height="11" rx="2"/>' +
    '<path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  /** The share strip a shopper can actually see, and one of its links to imitate. */
  function strip() {
    var links = [].slice.call(document.querySelectorAll(
      'a[href*="facebook.com/sharer"],a[href*="twitter.com/share"],a[href*="twitter.com/intent"],' +
      'a[href*="pinterest.com/pin"],a[href*="pinterest.com/pin/create"]'));
    for (var i = 0; i < links.length; i++) {
      if (!visible(links[i])) continue;                 // skip the themes' hidden duplicates
      var host = links[i].parentNode;
      if (!host) continue;
      return { host: host, like: links[i] };
    }
    return null;
  }

  /** What to share: the page exactly as configured, minus our own cache-busting noise. */
  function shareUrl() {
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('cb');
      u.hash = '';
      return u.toString();
    } catch (e) {
      return window.location.href;
    }
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // older Safari / non-secure contexts
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy') ? resolve() : reject();
      } catch (e) {
        reject(e);
      }
      document.body.removeChild(ta);
    });
  }

  function build() {
    if (document.querySelector('[' + MARK + ']')) return;   // idempotent
    var found = strip();
    if (!found) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute(MARK, '');
    btn.className = (found.like.className || '') + ' dvl-share-copy';
    btn.title = LABEL;

    var icon = document.createElement('span');
    icon.className = 'dvl-share-copy__icon';
    icon.innerHTML = ICON;

    var label = document.createElement('span');
    label.className = 'dvl-share-copy__label';
    label.textContent = LABEL;

    btn.appendChild(icon);
    btn.appendChild(label);

    /* The copied state is announced, not just coloured: the button's own text changing is the whole
       feedback, and a shopper using a screen reader gets nothing from a colour. */
    var live = document.createElement('span');
    live.className = 'dvl-share-copy__live';
    live.setAttribute('aria-live', 'polite');
    btn.appendChild(live);

    var timer = null;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      copy(shareUrl()).then(function () {
        label.textContent = DONE;
        live.textContent = 'Link copied to the clipboard';
        btn.classList.add('is-copied');
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          label.textContent = LABEL;
          live.textContent = '';
          btn.classList.remove('is-copied');
        }, 2200);
      }).catch(function () {
        label.textContent = 'Press Ctrl+C';
        live.textContent = 'Copy failed — the link is selected, press Ctrl+C';
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () { label.textContent = LABEL; live.textContent = ''; }, 3200);
      });
    }, false);

    found.host.appendChild(btn);
  }

  /* ------------------------------------------------------------------ the native share buttons
   * Facebook, Twitter and Pinterest are built in Liquid from the product URL, so they too carry no
   * variant and no SPO preset. Their hrefs are rewritten to the configured URL — otherwise Copy link
   * would send the built kit while the button beside it sent a blank product page.
   *
   * Each network carries the URL differently, and one of them does not carry it at all:
   *   facebook   ?u=<url>
   *   twitter    ?url=<url>, or the URL inside ?text= where the theme put it there (Fashionopolism)
   *   pinterest  ?url=<url>&media=…
   *   pinterest  as a `javascript:` bookmarklet (Galleria) — LEFT ALONE: it injects Pinterest's own
   *              script, which reads the live page, so it already gets the configured URL.
   */
  function syncSocial() {
    var url = shareUrl();
    var links = document.querySelectorAll(
      'a[href*="facebook.com/sharer"],a[href*="twitter.com/share"],a[href*="twitter.com/intent"],' +
      'a[href*="pinterest.com/pin"]');

    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var raw = a.getAttribute('href') || '';
      if (raw.indexOf('javascript:') === 0) continue;       // the bookmarklet reads the page itself

      // remember the theme's original once, so repeated syncs never compound
      var orig = a.getAttribute('data-dvl-href0');
      if (orig === null) {
        orig = raw;
        a.setAttribute('data-dvl-href0', raw);
      }

      var abs = orig.indexOf('//') === 0 ? window.location.protocol + orig : orig;
      var u;
      try {
        u = new URL(abs, window.location.origin);
      } catch (e) {
        continue;
      }

      if (u.searchParams.has('u')) u.searchParams.set('u', url);          // facebook
      if (u.searchParams.has('url')) u.searchParams.set('url', url);      // twitter / pinterest

      // Fashionopolism puts the bare URL in ?text= with no ?url= at all
      if (!u.searchParams.has('url') && u.searchParams.has('text')) {
        var text = u.searchParams.get('text') || '';
        u.searchParams.set('text', /https?:\/\//.test(text)
          ? text.replace(/https?:\/\/\S+/, url)
          : text + ' ' + url);
      }

      var next = orig.indexOf('//') === 0 ? u.toString().replace(/^https?:/, '') : u.toString();
      if (next !== raw) a.setAttribute('href', next);
    }
  }

  function boot() {
    build();
    syncSocial();

    /* The share strip can be re-rendered (variant switches redraw parts of the product meta on some
       themes), so rebuild if ours goes missing. Cheap: build() returns immediately once present. */
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        build();
        syncSocial();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });

    /* The URL changes without a navigation when the shopper switches variant or the SPO widget
       writes its preset, and neither fires an event this script can rely on across four themes. A
       last sync on the way into a click is what guarantees the href is current at the only moment
       that matters; the capture phase runs before the browser follows it. */
    document.addEventListener('pointerdown', syncSocial, true);
    document.addEventListener('focusin', syncSocial, true);
    window.addEventListener('popstate', syncSocial, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, false);
  } else {
    boot();
  }
})();
